import { createAsyncTypes } from 'utils/ActionCreator'

export const GENERAL_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'GENERAL_SETTINGS_REQUEST',
  'Settings/General/ShowSettings'
)
export const UPDATE_GENERAL_SETTINGS_REQUEST = createAsyncTypes(
  'UPDATE_GENERAL_SETTINGS_REQUEST',
  'Settings/General/ShowSettings'
)
export const DEL_LOGO_REQUEST = createAsyncTypes(
  'DEL_LOGO_REQUEST',
  'Settings/General/ShowSettings'
)

export const ADE_KILLSWITCH_REQUEST_ASYNC = createAsyncTypes(
  'ADE_KILLSWITCH_REQUEST',
  'Settings/General/ShowSettings'
)

export const ADE_KILLSWITCH_UPDATE = createAsyncTypes(
  'ADE_KILLSWITCH_UPDATE',
  'Settings/General/ShowSettings'
)

export const SSO_VALUES = {
  OKTA: 'okta',
  AZUREAD: 'azuread',
  PING: 'ping-identity',
}

export const SSO_LABELS = {
  [SSO_VALUES.OKTA]: 'Okta',
  [SSO_VALUES.AZUREAD]: 'Azure AD',
  [SSO_VALUES.PING]: 'Ping Identity',
}

export const FIRST_DAY_OF_WEEK = {
  SUN: 0,
  MON: 1,
}

export const WORKDAYS_VALUES = {
  ALL_WEEK: 3,
  SUN_THU: 2,
  MON_FRI: 1,
}

export const WORKDAYS_OPTIONS = [
  { value: WORKDAYS_VALUES.ALL_WEEK, label: 'All Week' },
  { value: WORKDAYS_VALUES.SUN_THU, label: 'Sunday - Thursday' },
  { value: WORKDAYS_VALUES.MON_FRI, label: 'Monday - Friday' },
]

export const SESSION_EXPIRY_OPTIONS = [
  { value: 60, label: '1 Hour' },
  { value: 180, label: '3 Hours' },
  { value: 720, label: '12 Hours' },
  { value: 1440, label: 'Daily' },
  { value: 10080, label: 'Weekly' },
  { value: 43800, label: 'Monthly' },
  { value: 525600, label: 'Annually' },
]
